import { render, staticRenderFns } from "./workout-search.vue?vue&type=template&id=a5f1d116&"
import script from "./workout-search.vue?vue&type=script&lang=js&"
export * from "./workout-search.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports